<template>
	<div class="">
		<div class="top">
			<img src="./assets/猜谱.png" alt="">
			<span>猜谱</span>
		</div>
		<div class="book">
			<ChessInfo :chess-sgf="item" v-for="item in page" :key="item.id"
				@click.native="$router.push({
						name:'question',
						params:{
							id: item.chess_sgf.id,
							chessSgf: item
						}
					})"></ChessInfo>
		</div>
		<div class="page">
			<router-link :to="{query: {page: Math.max(1, pageNum - 1) }}" replace>&lt;上一页</router-link>
			<span> | </span>
			<router-link :to="{query: {page: pageNum + 1}}" replace>下一页&gt;</router-link>
		</div>
	</div>
</template>

<script>
import ChessInfo from "./component/ChessInfo.vue"

export default {
	data() {
		return {
			chessSgfs: []
		}
	},
	computed: {
		page() {
			let pageSize = 12
			return this.chessSgfs.slice(pageSize * (this.pageNum - 1), pageSize * this.pageNum)
		},
		pageNum() {
			let n = parseInt(this.$route.query.page) || 1
			if (n <= 0) {
				return 1
			}
			let max = Math.ceil(this.chessSgfs.length / 12)
			if (n > max) {
				return max
			}
			return n
		}
	},
	created() {
		this.$http.get("/guess_chess/chess_books/" + this.$route.params.id)
			.then(res => res.data)
			.then(data => {
				this.chessSgfs = data
				// this.draw(document.getElementById("canvas"), data[0].sgf)
			})
	},

	components: {
		ChessInfo
	}
}
</script>

<style scoped>


.top {
	width: 980px;
	margin: auto;
	padding: 20px 10px 0 10px;
	color: white;
	font-size: 1.2em;
}
.top * {
	vertical-align: middle;
}
.book {
	display: flex;
	justify-content: space-around;
	flex-wrap: wrap;
	width: 980px;
	margin: auto;
	padding: 5px;
	background-color: #3b88c8;
}
.page {
	width: 980px;
	margin: auto;
	color: white;
	text-align: center;
	padding: 20px 0;
}
.page a {
	text-decoration: none;
}
.page a:link {
	color: white;
}
.page a:visited {
	color: white;
}
</style>



// WEBPACK FOOTER //
// Books.vue?72c4d4ca